import React, {useState} from 'react';
import {Conitaner, InputBox, InputBoxCont} from './TextInput.styles';

const TextInput = ({
  placeHolderText,
  value,
  labelText,
  onTextChange,
  isError,
  isRequired,
  startIcon,
  width,
  height,
  readOnly,
  name,
  register,
  maxLength,
  regexPattern,
  isValidator,
}) => {
  const [text, setText] = useState(value);

  const handleChange = e => {
    let val = e.target.value;
    if (isValidator) {
      val = validateNumericValues(val);
      setText(val);
      onTextChange && onTextChange(val, name);
      return;
    }
    if (regexPattern) {
      const sanitizedValue = val.replace(regexPattern, '');
      val = sanitizedValue;
    }
    setText(val);
    onTextChange && onTextChange(val, name);
  };

  //Can be different usecases to handle different validations so putting in a function
  //This function lets user enter only numeric values upto two decimal values
  function validateNumericValues(val) {
    let inputValue = val.replace(regexPattern, '');

    // Allow only one dot
    if (inputValue.split('.').length > 2) {
      inputValue = inputValue.slice(0, inputValue.lastIndexOf('.'));
    }

    // Allow only up to two decimal places
    const decimalParts = inputValue.split('.');
    if (decimalParts[1] && decimalParts[1].length > 2) {
      decimalParts[1] = decimalParts[1].slice(0, 2);
    }

    inputValue = decimalParts.join('.');

    return inputValue;
  }

  return (
    <Conitaner>
      {labelText && (
        <label>
          {labelText} {isRequired && <span>*</span>}
        </label>
      )}
      <InputBoxCont width={width} height={height}>
        {startIcon && (
          <span className="startIcon">
            <span className={`sprite ${startIcon}`}></span>
          </span>
        )}
        <InputBox
          type="text"
          placeholder={placeHolderText}
          readOnly={readOnly}
          startIcon={startIcon}
          onChange={handleChange}
          value={text}
          isError={isError}
          name={name}
          {...register}
          maxLength={maxLength}
        />
      </InputBoxCont>
    </Conitaner>
  );
};

export default TextInput;
